export const initialState = {
  fleets: [],
  fleetOptions: [],
  loading: true,
  addFleetDialog: false,
  addFleetOptionsDialog: false,
};

const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'LOADING':
      return { ...state, loading: true };
    case 'LOADED':
      return { ...state, loading: false };
    case 'SET_FLEETS_AND_FLEETOPTIONS':
      return { ...state, ...payload, loading: false };
    case 'SHOW_ADD_FLEET_DIALOG':
      return { ...state, addFleetDialog: payload };
    case 'CLOSE_ADD_FLEET_DIALOG':
      return { ...state, addFleetDialog: false };
    case 'SHOW_ADD_FLEET_OPTIONS_DIALOG':
      return { ...state, addFleetOptionsDialog: payload };
    case 'CLOSE_ADD_FLEET_OPTIONS_DIALOG':
      return { ...state, addFleetOptionsDialog: false };
    default:
      return state;
  }
};
export default reducer;
